export enum CartographyResourceBbxStatusEnum {
  Stop = 0, // Color:  RED
  Driving = 1, // Color : GREEN
  Uncertain = 2, // Color : YELLOW or ORANGE
  Unknow = 3, // Color: #2F373A
}
